// @flow

import Scrollchor from 'react-scrollchor'
import React from 'react'
import ChallengeEntry from '../challengeEntry/ChallengeEntry'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'

import { State } from '../../types/types'

type Props = {
  number: number,
  data: State,
  title: string,
  explainerText: string,
  voteHandler: Function,
}

export default function Challenge(props: Props) {
  return (
    <div className='ui container'>
      <div
        className='ui question container'
        id={`question-${props.number}`}
        style={{ textAlign: 'left' }}
      >
        <h2>
          <span className='title-text'>
            {props.number}. {props.title}
          </span>
          <Scrollchor to={'#nav'}>
            <div className='top-link'>
              <div className='arrow-text'>nach oben</div>{' '}
              <i className='chevron up icon' />
            </div>
          </Scrollchor>
        </h2>
      </div>
      <div className='ui text container'>
        <p className='explainer-text'>
          {props.explainerText}
        </p>
        {(props.number === 4) ?
          <p>
            <i> ACHTUNG: Auch wir sind nicht unfehlbar. Bei der zweiten Frage
                ist uns ein Lapsus unterlaufen. Nicht die Mitgliederzahl der
                Bundesversammlung ist seit 1962 fix, sondern jene des Nationalrats.
                Diese wurde damals auf 200 festgelegt. Im Ständerat kam es 1979
                zur letzten Änderung: Mit den zwei Vertretern des neuen Kantons Jura
                wuchs die kleine Kammer auf 46 Sitze. Da unsere Kandidatinnen und Kandidaten
                in dieser Frage nicht schlauer waren als wir, wirkt sie sich nicht
                auf die Gesamtpunktzahl aus.
              </i>
          </p> : null}
        {/* <div className='ui small info message'>
          <div className='content'>
            <div className='header'>Wir suchen die Leser-Challenge</div>
            <div>
              Die letzte
              Herausforderung soll von Ihnen kommen, liebe Leserinnen, liebe Leser. Senden Sie uns bis zum 15. September ihren Vorschlag für die
              Publikums-Challenge an die Mail-Adresse <b><a href='mailto:bern@derbund.ch?subject=Wahlchallenge-Vorschlag&cc=christoph.aebischer@derbund.ch,christian.zellweger@derbund.ch,martin.erdmann@derbund.ch'>bern@derbund.ch</a></b>.
              {' '}Die von der Jury ausgewählte Idee <b>wird mit einem Jahresabo für den «Bund» prämiert.</b>
            </div>
          </div>
  </div> */}
        <hr />
        <ChallengeEntry
          number={props.number}
          data={props.data}
          name={'henz'}
          handleVote={props.voteHandler}
        />
        <ChallengeEntry
          number={props.number}
          data={props.data}
          name={'blume'}
          handleVote={props.voteHandler}
        />
        <ChallengeEntry
          number={props.number}
          data={props.data}
          name={'zbinden'}
          handleVote={props.voteHandler}
        />
        <ChallengeEntry
          number={props.number}
          data={props.data}
          name={'tanner'}
          handleVote={props.voteHandler}
        />
        <ChallengeEntry
          number={props.number}
          data={props.data}
          name={'schweizer'}
          handleVote={props.voteHandler}
        />
        <div className='ui huge warning message'>
          <div className='content'>
            <div className='header'>Diskutieren Sie mit</div>
            <div>Ihre Meinung zur Wahlchallenge interessiert uns. Wie schlagen sich die Kandidierenden?
                Was ist Ihr Input zur aktuellen Herausforderung? <b><a href="https://stadtgespraech.derbund.ch/?p=2136">Melden Sie sich im Forum zur «Wahlchallenge» zu Wort.</a></b></div>
          </div>
        </div>
      </div>
    </div>
  )
}
